"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const React = require("react");
const fx_1 = require("../../lib/fx");
class ClickRelated extends React.Component {
    constructor() {
        super(...arguments);
        this.onClick = () => {
            return (new Promise((resolve, reject) => {
                if (!this.props.onClick) {
                    return resolve(true);
                }
                else {
                    this.props.onClick(this.props.item).then((isNext) => {
                        resolve(isNext);
                    }).catch((err) => {
                        reject(err);
                    });
                }
            })).then((isNext) => {
                if (!isNext) {
                    return;
                }
                switch (this.props.type) {
                    case 'article':
                        this.callJssdk('alphaNews', 'clickRelatedArticle');
                        break;
                    case 'video':
                        this.callJssdk('video', 'clickRelatedVideo');
                        break;
                    default:
                        break;
                }
            });
        };
        this.callJssdk = (clazz, method) => {
            fx_1.callJssdk(`${clazz}.${method}`, this.props.item).then((item) => {
                // if (!item.is_loadurl) {
                //     window.location.href = this.props.item.url;
                // }
            }).catch((error) => {
                console.error(error);
                window.location.href = this.props.item.url;
            });
        };
    }
    render() {
        return React.createElement("div", { onClick: this.onClick }, this.props.children);
    }
}
exports.default = ClickRelated;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiaW5kZXguanMiLCJzb3VyY2VSb290IjoiIiwic291cmNlcyI6WyJpbmRleC50c3giXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6Ijs7QUFBQSwrQkFBK0I7QUFDL0IscUNBQXlDO0FBUXpDLE1BQXFCLFlBQWEsU0FBUSxLQUFLLENBQUMsU0FBNEI7SUFBNUU7O1FBUVksWUFBTyxHQUFHLEdBQUcsRUFBRTtZQUNuQixPQUFPLENBQUMsSUFBSSxPQUFPLENBQUMsQ0FBQyxPQUFPLEVBQUUsTUFBTSxFQUFFLEVBQUU7Z0JBQ3BDLElBQUksQ0FBQyxJQUFJLENBQUMsS0FBSyxDQUFDLE9BQU8sRUFBRTtvQkFDckIsT0FBTyxPQUFPLENBQUMsSUFBSSxDQUFDLENBQUM7aUJBQ3hCO3FCQUFNO29CQUNILElBQUksQ0FBQyxLQUFLLENBQUMsT0FBTyxDQUFDLElBQUksQ0FBQyxLQUFLLENBQUMsSUFBSSxDQUFDLENBQUMsSUFBSSxDQUFDLENBQUMsTUFBTSxFQUFFLEVBQUU7d0JBQ2hELE9BQU8sQ0FBQyxNQUFNLENBQUMsQ0FBQztvQkFDcEIsQ0FBQyxDQUFDLENBQUMsS0FBSyxDQUFDLENBQUMsR0FBRyxFQUFFLEVBQUU7d0JBQ2IsTUFBTSxDQUFDLEdBQUcsQ0FBQyxDQUFDO29CQUNoQixDQUFDLENBQUMsQ0FBQztpQkFDTjtZQUNMLENBQUMsQ0FBQyxDQUFDLENBQUMsSUFBSSxDQUFDLENBQUMsTUFBZSxFQUFFLEVBQUU7Z0JBQ3pCLElBQUksQ0FBQyxNQUFNLEVBQUU7b0JBQ1QsT0FBTztpQkFDVjtnQkFDRCxRQUFRLElBQUksQ0FBQyxLQUFLLENBQUMsSUFBSSxFQUFFO29CQUNyQixLQUFLLFNBQVM7d0JBQ1YsSUFBSSxDQUFDLFNBQVMsQ0FBQyxXQUFXLEVBQUUscUJBQXFCLENBQUMsQ0FBQzt3QkFDbkQsTUFBTTtvQkFDVixLQUFLLE9BQU87d0JBQ1IsSUFBSSxDQUFDLFNBQVMsQ0FBQyxPQUFPLEVBQUUsbUJBQW1CLENBQUMsQ0FBQzt3QkFDN0MsTUFBTTtvQkFDVjt3QkFDSSxNQUFNO2lCQUNiO1lBQ0wsQ0FBQyxDQUFDLENBQUM7UUFDUCxDQUFDLENBQUE7UUFFTyxjQUFTLEdBQUcsQ0FBQyxLQUFhLEVBQUUsTUFBYyxFQUFFLEVBQUU7WUFDbEQsY0FBUyxDQUFDLEdBQUcsS0FBSyxJQUFJLE1BQU0sRUFBRSxFQUFFLElBQUksQ0FBQyxLQUFLLENBQUMsSUFBSSxDQUFDLENBQUMsSUFBSSxDQUNqRCxDQUFDLElBQVMsRUFBRSxFQUFFO2dCQUNWLDBCQUEwQjtnQkFDMUIsa0RBQWtEO2dCQUNsRCxJQUFJO1lBQ1IsQ0FBQyxDQUNKLENBQUMsS0FBSyxDQUFDLENBQUMsS0FBVSxFQUFFLEVBQUU7Z0JBQ25CLE9BQU8sQ0FBQyxLQUFLLENBQUMsS0FBSyxDQUFDLENBQUM7Z0JBQ3JCLE1BQU0sQ0FBQyxRQUFRLENBQUMsSUFBSSxHQUFHLElBQUksQ0FBQyxLQUFLLENBQUMsSUFBSSxDQUFDLEdBQUcsQ0FBQztZQUMvQyxDQUFDLENBQUMsQ0FBQztRQUNQLENBQUMsQ0FBQTtJQUNMLENBQUM7SUE5Q1UsTUFBTTtRQUNULE9BQU8sNkJBQUssT0FBTyxFQUFFLElBQUksQ0FBQyxPQUFPLElBQzVCLElBQUksQ0FBQyxLQUFLLENBQUMsUUFBUSxDQUNsQixDQUFDO0lBQ1gsQ0FBQztDQTBDSjtBQWhERCwrQkFnREMifQ==